<template>
      <button v-if="isMounted && tree" class="btn btn-dark " style="padding:6px 10px; margin:0; font-size:13px;" data-bs-toggle="modal" :data-bs-target="'#Modal' + tree.TbtnId">▼ {{ tree.multiple ? "(" + tree.selectedNodeIds.length + "개)" : (tree.selectedNode ? tree.selectedNode.name : "학원/클래스 선택") }}</button>
</template>

<script>
export default {
    name: "treebtn",
    props: {
        tree: Object
    },
    data(){
        return {
            isMounted: false
        }
    },
    mounted(){
        this.isMounted = true;
    }
}
</script>
